import {DatiPagamento} from './DatiPagamento';
import {ParametriRicercaPagamenti} from '../../amministra-portale/gestisci-utenti/model/ParametriRicercaPagamenti';

export class ListaPagamentiFiltri {
  listaPagamenti: DatiPagamento[];
  filtri: ParametriRicercaPagamenti;
}
